import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full min-h-screen font-sans" data-id="element-500">
      <Navbar data-id="element-501" />
      <main className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-502">
        <h1 className="text-3xl font-bold mb-6" data-id="element-503">
          FluidForm, Inc. — Privacy Policy
        </h1>
        <p className="text-gray-600 mb-8" data-id="element-504">Last Updated: August 16, 2025</p>
        <p className="mb-8" data-id="element-505">
          Welcome to FluidForm, Inc. ("FluidForm," "we," "us," or "our"). This
          Privacy Policy describes how we collect, use, and share information
          about you when you use our services ("Services"). By using our
          Services, you agree to the terms outlined in this policy.
        </p>
        <section className="mb-8" data-id="element-506">
          <h2 className="text-xl font-semibold mb-4" data-id="element-507">
            1. Changes to This Privacy Policy
          </h2>
          <p className="mb-4" data-id="element-508">
            We may update this policy occasionally. If material changes occur,
            we will notify you (e.g., via email or in-product notification).
            Your continued use of the Services after the update constitutes
            acceptance.
          </p>
        </section>
        <section className="mb-8" data-id="element-509">
          <h2 className="text-xl font-semibold mb-4" data-id="element-510">
            2. Information We Collect
          </h2>
          <h3 className="text-lg font-medium mb-2" data-id="element-511">
            A. Information You Provide
          </h3>
          <ul className="list-disc pl-8 mb-4" data-id="element-512">
            <li className="mb-2" data-id="element-513">
              <span className="font-medium" data-id="element-514">Account Info:</span> Such as email,
              name, and billing details.
            </li>
            <li className="mb-2" data-id="element-515">
              <span className="font-medium" data-id="element-516">Support Communications:</span>{' '}
              Information you send when contacting support.
            </li>
            <li className="mb-2" data-id="element-517">
              <span className="font-medium" data-id="element-518">User Content:</span> Any content you
              upload, create, or submit within the Services.
            </li>
          </ul>
          <h3 className="text-lg font-medium mb-2" data-id="element-519">
            B. Automatically Collected Info
          </h3>
          <ul className="list-disc pl-8 mb-4" data-id="element-520">
            <li className="mb-2" data-id="element-521">
              <span className="font-medium" data-id="element-522">Device & Usage Data:</span> Includes
              IP address, browser type, device identifiers, time stamps, and
              activity logs.
            </li>
            <li className="mb-2" data-id="element-523">
              <span className="font-medium" data-id="element-524">
                Cookies & Tracking Technologies:
              </span>{' '}
              We use cookies and similar tools for functionality, analytics, and
              improving your experience.
            </li>
          </ul>
          <h3 className="text-lg font-medium mb-2" data-id="element-525">C. Third-Party Data</h3>
          <p className="mb-4" data-id="element-526">
            We may receive information from third parties (e.g., if you sign up
            via Google or Slack), subject to your permissions and their
            policies.
          </p>
        </section>
        <section className="mb-8" data-id="element-527">
          <h2 className="text-xl font-semibold mb-4" data-id="element-528">
            3. How We Use Your Information
          </h2>
          <p className="mb-4" data-id="element-529">We use your data to:</p>
          <ul className="list-disc pl-8 mb-4" data-id="element-530">
            <li className="mb-2" data-id="element-531">
              Provide, maintain, and enhance the Services.
            </li>
            <li className="mb-2" data-id="element-532">
              Communicate updates, respond to inquiries, and send technical
              notices.
            </li>
            <li className="mb-2" data-id="element-533">Process payments and manage subscriptions.</li>
            <li className="mb-2" data-id="element-534">Personalize your user experience.</li>
            <li className="mb-2" data-id="element-535">
              Protect against fraud and ensure safety and integrity.
            </li>
            <li className="mb-2" data-id="element-536">Comply with legal obligations.</li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-537">
          <h2 className="text-xl font-semibold mb-4" data-id="element-538">
            4. Information Sharing & Disclosure
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-539">
            <li className="mb-2" data-id="element-540">
              <span className="font-medium" data-id="element-541">Service Providers:</span> We share
              your info with vendors assisting in operations (e.g., payment
              processors, analytics tools).
            </li>
            <li className="mb-2" data-id="element-542">
              <span className="font-medium" data-id="element-543">Legal & Safety:</span> We disclose
              information if required by law or to protect rights.
            </li>
            <li className="mb-2" data-id="element-544">
              <span className="font-medium" data-id="element-545">Aggregated Data:</span> We may use
              anonymized, aggregated data for analytics or research.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-546">
          <h2 className="text-xl font-semibold mb-4" data-id="element-547">
            5. Data Retention & Deletion
          </h2>
          <p className="mb-4" data-id="element-548">
            We retain personal data as long as necessary to provide the
            Services, comply with legal obligations, or for legitimate business
            purposes. You may request deletion of your personal information in
            compliance with applicable laws.
          </p>
        </section>
        <section className="mb-8" data-id="element-549">
          <h2 className="text-xl font-semibold mb-4" data-id="element-550">
            6. Your Privacy Choices
          </h2>
          <ul className="list-disc pl-8 mb-4" data-id="element-551">
            <li className="mb-2" data-id="element-552">
              <span className="font-medium" data-id="element-553">Account Settings:</span> Manage
              notifications, data preferences, or privacy-related toggles where
              applicable.
            </li>
            <li className="mb-2" data-id="element-554">
              <span className="font-medium" data-id="element-555">Opt-Out Rights:</span> You may opt
              out of non-essential communications or data uses as allowed by
              law.
            </li>
            <li className="mb-2" data-id="element-556">
              <span className="font-medium" data-id="element-557">Access & Deletion Requests:</span>{' '}
              Contact us to access, update, or delete your information—subject
              to lawful exceptions.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-558">
          <h2 className="text-xl font-semibold mb-4" data-id="element-559">7. Security Measures</h2>
          <p className="mb-4" data-id="element-560">
            We employ administrative, technical, and physical safeguards to
            protect your information. We regularly review our practices and
            engage with third-party audits and assessments to ensure data
            protection.
          </p>
        </section>
        <section className="mb-8" data-id="element-561">
          <h2 className="text-xl font-semibold mb-4" data-id="element-562">8. Privacy of Minors</h2>
          <p className="mb-4" data-id="element-563">
            Users must be at least 13 years old to use our Services. We do not
            knowingly collect personal data from children under 13. If you're
            under 13, please do not provide personal data.
          </p>
        </section>
        <section className="mb-8" data-id="element-564">
          <h2 className="text-xl font-semibold mb-4" data-id="element-565">9. International Users</h2>
          <p className="mb-4" data-id="element-566">
            If you're in regions like the EU, UK, or other privacy-regulated
            areas, we comply with applicable laws such as GDPR. Contact us if
            you'd like to understand how your rights apply.
          </p>
        </section>
        <section className="mb-8" data-id="element-567">
          <h2 className="text-xl font-semibold mb-4" data-id="element-568">10. Contact Us</h2>
          <p className="mb-4" data-id="element-569">
            If you have any questions or concerns about this policy, contact us
            at:
          </p>
          <p className="mb-4" data-id="element-570">
            FluidForm, Inc.{' '}
            <a href="mailto:support@fluid-form.ai" className="text-blue-600 hover:underline" data-id="element-571">
              support@fluid-form.ai
            </a>
          </p>
        </section>
      </main>
      <Footer data-id="element-572" />
    </div>;
};
export default PrivacyPolicy;